import React, { useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../utils/redux/hooks";
import { getServices } from "../../utils/apis/func";
import { addisLoading, addservices } from "../../utils/redux/mainSlice";
import { RootState } from "../../utils/redux/store";

import Services from "../helpers/servicesTabsTemp/services";
import PersonalServices from "../helpers/servicesTabsTemp/personalServices";
import EditCategory from "../helpers/servicesTabsTemp/editCategory";
import EditSubCategory from "../helpers/servicesTabsTemp/editSubCategory";
import AddCategory from "../helpers/servicesTabsTemp/addCategory";
import AddSubCategory from "../helpers/servicesTabsTemp/addSubCategory";

const ServicesContent = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const items = [
    "Services",
    // "Personal Services",
    // "Edit Services",
    // "Edit Sub Category",
    "Category",
    // "Add Sub Category",
  ];
  const dispatch = useAppDispatch();
  useEffect(() => {
    const fetchServices = async () => {
      dispatch(addisLoading(true));
      const res: any = await getServices("");
      console.log(res);
      if (res?.status === 200 || res?.status === 201) {
        dispatch(addservices(res?.data?.services));
      }
      dispatch(addisLoading(false));
    };
    fetchServices();
  }, [dispatch]);
  const [currentPage, setCurrentPage] = useState(1);
  const services = useAppSelector((store: RootState) => store.user.services);
  const itemsPerPage = 15;
  const totalItems = services?.length;
  const allItems = Array.from({ length: itemsPerPage }, (_, index) => ({
    id: index + 1,
    dateTime: {
      date: `16 Sep 2023`,
      time: `13:56`,
    },
    category: `0805214256$`,
    totalOrders: `example@example.com`,
    status: ``,
    action: ``,
  }));
  console.log(allItems);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
  const itemsToShow = services?.slice(startIndex, endIndex);

  const handlePrevPageClick = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPageClick = () => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };



  return (
    // <div className="">
    //   <div className="flex justify-between my-2 px-6">
    //     <p className="text-[#88087B] font-roboto text-3xl font-medium leading-normal">
    //       Services
    //     </p>
    //     <FaPlus
    //       size={25}
    //       className="text-[#fff] bg-[#88087B] p-1  rounded-md"
    //     />
    //   </div>
    //   <section className="px-3">
    //     <div className="relative overflow-x-auto px-3 rounded-t-lg">
    //       <table className="w-full">
    //         <thead className="bg-[#88087B] text-[#F7F7F7] font-roboto text-lg font-medium">
    //           <tr>
    //             <th className="py-3 px-10">Date</th>
    //             <th className="py-3 px-10">Category</th>
    //             <th className="py-3 px-10">Total Orders</th>
    //             <th className="py-3 px-10">Status</th>
    //             <th className="py-3 px-10">Action</th>
    //           </tr>
    //         </thead>
    //         <tbody>
    //           {itemsToShow.map((item) => (
    //             <tr
    //               key={item.id}
    //               className="hover:bg-[#87878d] transition duration-300 font-roboto text-xs font-medium leading-normal border border-b-[#525050]"
    //             >
    //               {/* <td className="py-4 px-16 text-center">
    //                 <div>{item.dateTime.date}</div>
    //                 <div>{item.dateTime.time}</div>
    //               </td>
    //               <td className="py-4 px-16">{item.category}</td>
    //               <td className="py-4 px-16">{item.totalOrders}</td> */}
    //               <td className="py-4 items-center pl-4  text-center">
    //                 {formatDate(item?.createdAt)}
    //               </td>
    //               <td className="py-4 px-16">{item?.name}</td>
    //               <td className="py-4 px-16">0</td>
    //               <td className="py-4 px-16">
    //                 <MdToggleOn
    //                   size={24}
    //                   className="text-[#1A6C13] bg-[#fff]  border border-[fff] rounded-lg"
    //                 />
    //               </td>
    //               <td className="py-4 px-16">
    //                 <MdEdit size={24} />
    //               </td>
    //             </tr>
    //           ))}
    //         </tbody>
    //       </table>
    //     </div>
    //     <div className="  flex justify-end px-4 mt-8 -mb-8 ">
    //       <p className="bg-[#88087B] border border-[#88087B] px-2 rounded-md text-[#FFCD1E] text-center text-shadow font-roboto text-base font-medium leading-normal">
    //         Export

    //       </p>
    //     ))}
    //   </div>
    //   {items.map((item, index) => (
    //     <div
    //       key={index}
    //       style={{
    //         display: index === selectedTab ? "block" : "none",
    //       }}
    //     >
    //       {index === 0 && <Services />}
    //       {index === 1 && <PersonalServices />}
    //       {index === 2 && <EditCategory />}
    //       {index === 3 && <EditSubCategory />}
    //       {index === 4 && <AddCategory />}
    //       {index === 5 && <AddSubCategory />}
    //     </div>
    //   ))}
    // </div>
    <div className="">
      <div className="flex px-3 gap-4 lg:gap-12 overflow-x-auto lg:overflow-hidden ">
        {items.map((item, index) => (
          <p
            key={index}
            className={`font-roboto items-center text-center  text-base font-medium w-1/3 leading-normal text-lg cursor-pointer whitespace-nowrap ${
              index === selectedTab ? "border-b-2 border-[#88087B]" : ""
            }`}
            onClick={() => setSelectedTab(index)}
          >
            {" "}
            {item}{" "}
          </p>
        ))}
      </div>
      {items.map((item, index) => (
        <div
          key={index}
          className="mt-4"
          style={{
            display: index === selectedTab ? "block" : "none",
          }}
        >
          {index === 0 && <Services />}
          {index === 1 && <AddCategory />}
          {index === 2 && <EditCategory />}
          {index === 3 && <EditSubCategory />}
          {index === 4 && <PersonalServices />}
          {index === 5 && <AddSubCategory />}
        </div>
      ))}
    </div>
  );
};

export default ServicesContent;
